import { render, staticRenderFns } from "./StartForm10.vue?vue&type=template&id=431b2eb0&scoped=true"
import script from "./StartForm10.vue?vue&type=script&lang=ts"
export * from "./StartForm10.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431b2eb0",
  null
  
)

export default component.exports